var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config,"isTabs":""}})}
var staticRenderFns = []

export { render, staticRenderFns }